// extracted by mini-css-extract-plugin
export default {"cls1":"FeedFilters-cls1_WH5","cls2":"FeedFilters-cls2_K5J FeedFilters-cls1_WH5"};